// The player read a direct message conversation in one of their sessions. The
// server pushes direct_message_read (services\chat\read\DirectMessageReadCursor)
// to all of them with the new unread conversation count.
export const DIRECT_MESSAGE_READ = 'DIRECT_MESSAGE_READ';

export const directMessageRead = ({ other_player_id: otherPlayerId, last_read_message_id: lastReadMessageId, unread_conversation_count: unreadConversationCount }) => ({
	type: DIRECT_MESSAGE_READ,
	payload: {
		otherPlayerId: Number(otherPlayerId),
		lastReadMessageId: Number(lastReadMessageId),
		unreadConversationCount: Number(unreadConversationCount) || 0,
	},
});
